import { DTO, Types } from 'shared-lib';
import { DashboardStatsDTO } from './admin.dto';

export enum StatCardColor {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum HeatmapDataType {
  RIDE_START = 'ride_start',
  RIDE_END = 'ride_end',
  DRIVER_LOCATION = 'driver_location',
  HOTSPOT = 'hotspot',
  ALL = 'all',
  UNKNOWN = 'unknown',
}

export enum TrendDirection {
  UP = 'up',
  DOWN = 'down',
}

export type HeatmapDataPoint = {
  lat: number;
  lng: number;
  weight?: number;
  timestamp?: Date;
  type?: HeatmapDataType;
  metadata?: {
    driverId?: number;
    rideId?: number;
    riderId?: number;
    duration?: number;
    fare?: number;
  };
};

export type HeatmapFilters = {
  dateRange?: {
    start: Date;
    end: Date;
  };
  timeRange?: {
    startHour: number;
    endHour: number;
  };
  dataType?: HeatmapDataType;
  minWeight?: number;
  maxWeight?: number;
};

// Interface para configuração do mapa
export interface MapConfig {
  center: {
    lat: number;
    lng: number;
  };
  zoom: number;
  options: Record<string, unknown>;
}

export type MapFilters = {
  showDrivers: boolean;
  showHeatmap: boolean;
  heatmapType: HeatmapDataType;
};

// Interface para dados do dashboard
export interface DashboardData {
  ongoingRidesCount: number;
  completedRidesCount: number;
  onlineDriversCount: number;
  totalDriversCount: number;
}

// Interface para resposta da API do dashboard
export interface DashboardApiResponse {
  message: string;
  data: DashboardData;
}

// Interface para driver online
export interface OnlineDriver {
  id: number;
  firstName: string;
  lastName: string;
  liveLocation: [number, number];
  status: Types.DriverStatusEnum;
  vehicle?: {
    vehicleNumber: string;
    vehicleType: string;
  };
}

// Interface para resposta de drivers online
export interface OnlineDriversResponse {
  data: OnlineDriver[];
  totalCount: number;
}

// Interface para estado do componente Dashboard
export interface DashboardState {
  intervalState: ReturnType<typeof setInterval> | null;
  allOnlineDrivers: OnlineDriver[];
  dashboardData: DashboardStatsDTO | null;
  isLoading: boolean;
  isSpinner: boolean;
  ongoingRidesCount: number;
  completeRidesCount: number;
  onlineDriversCount: number;
  totalDriver: number;
  totalRiders: number;
  totalRevenue: number;
  todayRides: number;
  weeklyData: { date: string; rides: number; revenue: number }[];
}

// Interface para marcador do mapa
export interface MapMarker {
  id: string;
  position: {
    lat: number;
    lng: number;
  };
  title: string;
  icon?: string;
  driver?: OnlineDriver;
}

// Interface para estatísticas do dashboard
export interface DashboardStats {
  rides: {
    ongoing: number;
    completed: number;
    total: number;
    growthRate: number;
  };
  drivers: {
    online: number;
    total: number;
    activeRate: number;
  };
  revenue: {
    today: number;
    thisMonth: number;
    growthRate: number;
  };
  performance: {
    averageRideTime: number;
    completionRate: number;
    customerSatisfaction: number;
  };
}

// Interface para card de estatística
export interface StatCard {
  title: string;
  value: number | string;
  icon: string;
  color: StatCardColor;
  trend?: {
    value: number;
    direction: TrendDirection;
    period: string;
  };
  onClick?: () => void;
}

// Interface para erro de API do dashboard
export interface DashboardApiError {
  message: string;
  code?: string;
  status?: number;
}
